<template>
  <div class="task taskSearcher">
    <transition name="fade" mode="out-in">
      <searcher
        :key="this.task.taskId"
        :contentId="definitionId"
        :fromTask="true"
        :endpointTask="task.type.endpoint"
        :id="getDefinitionContentId()"
        :code="getDefinitionContentCode()"
        :menuId="task.menuId"
        :taskObject="object"
        :taskDefinition="definition"
        :istoggle="istoggle"
        :taskType="task.type"
        @refreshDefinitionContent="refreshDefinitionContent"
      />
    </transition>
  </div>
</template>

<script>
import language from '../../language'
// import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'definition-task-searcher',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'apiparams',
    'visuals',
    'istoggle',
    'callTask'
  ],
  components: {
    Searcher: () => import('@/components/content/searcher/index.vue') // comment for 'definition.js' low size // Webpack’s asynchronous import for recursivity components
  },
  data () {
    return {
    }
  },
  methods: {
    getLang (key) {
      return language(this.language, key)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getDefinitionContentId () {
      var result
      var object = this.object[0]

      if (this.task.type.id === 'searcherByField') {
        if (this.definition.type === 'mono-choice') {
          if (object.domainValue && object.domainValue.length === 1) {
            result = object.domainValue[0].key
          } else {
            result = null
          }
        } else {
          result = object.textValue
        }
      } else {
        result = this.definitionContentId
      }

      return result
    },
    getDefinitionContentCode () {
      var result
      if (this.task.type.id === 'searcherByField') {
        result = null
      } else {
        result = this.repeatableGroupCode
      }

      return result
    }
  }
}
</script>

<style lang="scss">
.taskSearcher {
  .contenidor_taula {
    #resultados {
      padding-bottom: 20px;
    }
    .noResults {
      padding: 20px;
      min-height: initial;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/task/taskSearcher.vue